import(/* webpackMode: "eager" */ "/vercel/path0/src/app/inventory/page.tsx");
